import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { RolesDto } from "./roles.dto";

export class RolesResponse extends GlobalResponseObject{

      data?: RolesDto;
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status:boolean, intlCode:number, internalMessage:string, data?: RolesDto){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.internalMessage = internalMessage;
        this.intlCode = intlCode;
        this.data = data;
    }

}